import React from 'react';
import StatusBadge from './StatusBadge';
import { getReferencesForLaw } from '../data/references';

function StateModal({ state, onClose }) {
  if (!state) return null;

  const references = getReferencesForLaw(state.lawName, state.category);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto"
      onClick={onClose}
    >
      <div className="min-h-screen px-4 py-8 flex items-center justify-center">
        <div
          className="bg-slate-50 rounded-lg max-w-3xl w-full my-8 shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="max-h-[85vh] overflow-y-auto">
            <div className="sticky top-0 bg-slate-50 border-b border-slate-200 px-6 py-4 flex justify-between items-center z-10">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  {state.state || state.country}
                  {state.region && <span className="text-sm text-gray-500 ml-2">({state.region})</span>}
                </h2>
                <p className="text-gray-500">{state.lawName}</p>
              </div>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600"
              >
                <i className="fas fa-times text-2xl"></i>
              </button>
            </div>

            <div className="p-6">
              <div className="flex items-center gap-4 mb-6">
                <StatusBadge status={state.status} />
                <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm font-medium">
                  {state.category}
                </span>
              </div>

              <div className="space-y-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="fas fa-calendar-alt text-purple-600 mr-2"></i>
                    Effective Date
                  </h3>
                  <p className="text-gray-700">{state.effectiveDate}</p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="fas fa-child text-purple-600 mr-2"></i>
                    Age Range
                  </h3>
                  <p className="text-gray-700">{state.ageRange}</p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="fas fa-building text-purple-600 mr-2"></i>
                    Applicability
                  </h3>
                  <p className="text-gray-700">{state.applicability}</p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="fas fa-list-check text-purple-600 mr-2"></i>
                    Key Requirements
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {state.keyRequirements.map((req, idx) => (
                      <li key={idx}>{req}</li>
                    ))}
                  </ul>
                </div>

                {state.notes && (
                  <div className="p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                    <h3 className="font-semibold text-yellow-900 mb-2 flex items-center">
                      <i className="fas fa-exclamation-triangle mr-2"></i>
                      Important Note
                    </h3>
                    <p className="text-yellow-800">{state.notes}</p>
                  </div>
                )}

                {/* Learn More Section */}
                {references.length > 0 && (
                  <div className="border-t border-gray-200 pt-6">
                    <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="fas fa-book-open text-purple-600 mr-2"></i>
                      Learn More on Compliance Hub
                    </h3>
                    <div className="space-y-3">
                      {references.map((ref, idx) => (
                        <a
                          key={idx}
                          href={ref.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block p-4 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors group"
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="font-semibold text-purple-900 group-hover:text-purple-700 flex items-center">
                                {ref.title}
                                <i className="fas fa-external-link-alt ml-2 text-xs"></i>
                              </div>
                              <p className="text-sm text-purple-700 mt-1">{ref.description}</p>
                            </div>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StateModal;
